import React, { useState, useEffect } from 'react';
import MainCard from '../../../components/MainCard/MainCard';
import { Col, Row, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
//Components
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
//Api
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import gerador_api from '../../../api/gerador_api';
import prefeitura_api from '../../../api/prefeitura_api';
import relatorio_api from '../../../api/relatorio_api';
//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import RelatorioColetasPorGerador from './RelatorioColetasPorGerador';

//Context
import { useAuth } from '../../../context/auth';

function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");
    return {
        dataInicial,
        dataFinal,
        modalidadeId: 0,
        modalidadeId_selected: null,
        geradorId: 0,
        geradorId_selected: null,
        localidadeId: 0,
        localidadeId_selected: null,
        status: "TODOS",
        nomeRelatorio: "Relatórios - Coletas por Gerador"
    }
}

export default function ColetasPorGerador() {
    const { setupVariavel } = useAuth();

    //Variavel utilizada para navegação 
    const navigate = useNavigate();
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});
    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
        objCampo({ name: "geradorId_selected", required: true }),
    ]
    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState();

    //Opções de transportadores
    const [optionsGeradores, setOptionsGeradores] = useState();

    //Opções de localidades
    const [optionsLocalidades, setOptionsLocalidades] = useState();

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Opções do select de status
    const optionsStatus = [
        { value: "TODOS", text: "Todos" },
        { value: "COLETADO", text: "Coletado" },
        { value: "BAIXADO", text: "Recebido" },
        { value: "NÃO COLETADO", text: "Recusado" },
    ]
    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e localidade
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        });
    }
    const onChangeGerador = (e, select) => {
        const { name } = select;
        if (e) {
            gerador_api.GetItem(e.value).then(response => {
                response.data.localidades = response.data.localidades.map(value => {
                    return { value: value.id, label: value.logradouro + ', ' + value.numero + ' - ' + value.bairro + ', ' + value.cidade + ' - ' + value.uf + ' - ' + value.cep }
                })
                setOptionsLocalidades(response.data.localidades);
            }).catch(e => showMessage("Aviso", e.message, "error", null));
        }

        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0,
            localidadeId: 0,
            localidadeId_selected: null
        });
    }
    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }

        setLoading(true);
        relatorio_api.DetalhadoPorGerador(filtros).then(response => {
            response.data.listaColetas = response.data.listaColetas.map(coleta => {
                Object.keys(coleta).map(value => {
                    coleta.volume = parseFloat(coleta.volume).toFixed(2) + " " + coleta.unidade;
                    if (!coleta[value]) {
                        coleta[value] = "Sem informação";
                    }
                });
                return coleta;
            });

            response.data.totalizadoresStatusModalidade = response.data.totalizadoresStatusModalidade.map(value => {
                value.titulo = value.titulo.replace("MTR", setupVariavel?.siglaDocumentoColeta)
                return value;
            });

            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    //Carrega as modalidades de coleta e os geradores para o select
    useEffect(() => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setOptionsModalidades(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
        prefeitura_api.GetList().then(response => {
            gerador_api.GetList(response.data[0].id).then(response => {
                response.data = response.data.map(value => {
                    return { label: value.fantasia, value: value.id }
                });
                setOptionsGeradores(response.data);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            });
        });
    }, []);
    if (dadosRelatorio) {
        return <RelatorioColetasPorGerador dadosRelatorio={dadosRelatorio} btnVoltar={() => setDadosRelatorio(null)} filtros={filtros} />
    }
    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório de coletas por gerador</h4>
            <Row>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataInicial" label={"* Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} invalid={!!errors.dataInicial} />
                    <PrintValidate field={"dataInicial"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataFinal" label={"* Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField placeholder='Selecione' name="modalidadeId_selected" label={"Modalidade"} type={"select"} searchable value={filtros.modalidadeId_selected} invalid={!!errors.modalidadeId_selected} onChange={onChangeSelected} options={optionsModalidades} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="geradorId_selected" label={"* Gerador"} type={"select"} searchable value={filtros.geradorId_selected} invalid={!!errors.geradorId_selected} onChange={onChangeGerador} options={optionsGeradores} />
                    <PrintValidate field={"geradorId_selected"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField placeholder='Todos' name="localidadeId_selected" label={"Localidade"} type={"select"} searchable value={filtros.localidadeId_selected} invalid={!!errors.localidadeId_selected} onChange={onChangeSelected} options={optionsLocalidades} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="status" label={"* Status"} type={"select"} value={filtros.status} invalid={!!errors.status} onChange={onChangeFiltros} options={optionsStatus} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}